import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { MORTGAGE_PROVIDERS } from "../../utils/constants"
import Modal from "../../components/Modal"
import { ChevronDown } from "lucide-react"
import { useField, useFormikContext } from "formik"
import clsx from "clsx"

const ProviderModal = ({ className, ...props }) => {
    const [field] = useField(props)
    const formik = useFormikContext()
    const [showModal, setShowModal] = useState(false)
    const { t } = useTranslation()

    const handleSelectProvider = (provider) => {
        formik.setFieldValue(field.name, provider)
        setShowModal((prevVal) => !prevVal)
    }
    const closeModal = () => setShowModal((prevVal) => !prevVal)
    return (
        <>
            <div className={className}>
                <div
                    className={clsx("relative h-full flex cursor-pointer items-center")}
                    onClick={() => setShowModal((prevVal) => !prevVal)}
                >
                    <div className={clsx(!field?.value && "text-base text-neutral-300")}>
                        {field?.value
                            ? MORTGAGE_PROVIDERS[field?.value]
                            : props.placeholder}
                    </div>
                    <ChevronDown
                        color="#A8AAB8"
                        className="absolute right-1 top-1/2 transform -translate-y-1/2 w-4 h-4"
                    />
                </div>
            </div>
            {showModal && (
                <Modal onToggle={closeModal} isVisible={showModal}>
                    <div className="flex flex-col h-full">
                        <div className="page-title-small text-center mb-8 ">
                            {t("labels.select-provider")}
                        </div>
                        <div className="flex flex-col flex-1 space-y-4">
                            {Object.keys(MORTGAGE_PROVIDERS).map((key) => (
                                <div
                                    className="flex items-center cursor-pointer border-b pb-4 last:border-0"
                                    onClick={() => handleSelectProvider(key)}
                                    key={`provider-${key}`}
                                >
                                    <div className="ml-4 text-accumin-neutral-500">
                                        {MORTGAGE_PROVIDERS[key]}
                                    </div>
                                    <button
                                        className={clsx(
                                            "select-button ml-auto",
                                            field.value === key ? "selected" : "unselected"
                                        )}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal>
            )}
        </>
    )
}

export default ProviderModal